import * as React from 'react'
import { FormEvent, useEffect, useState } from "react";
import { Dropdown, IconButton, IDropdownOption, IDropdownStyles, Label, Spinner, SpinnerSize } from "@fluentui/react";
import { IPaginacionComponent } from '../../interfaces/base/ITable';
import { FlechaMayor, FlechaMenor } from '../../utils/Theme/IconsSVG';

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: {
        width: 'auto',
        border: 'none'
    },
};


const MENU_ITEMS_PAGINACION = [
    { key: "10", text: "10 Items" },
    { key: "50", text: "50 Items" },
    { key: "100", text: "100 Items" },
]
export const PaginationComponent = (props: IPaginacionComponent) => {
    const [skipPagination, setSkipPagination] = useState<number>(props.skipPagination ?? 0)
    useEffect(() => {
        if (props.skipPagination == 0 && skipPagination != 0) {
            setSkipPagination(0)
        }
    }, [props.skipPagination])

    const onCheckedValueChange = (event: FormEvent<HTMLDivElement>, data?: IDropdownOption) => {
        const ver = (data == null ? "0" : data.key).toString()
        if (props.onChangeTake) props.onChangeTake(Number.parseInt(ver));
    };
    const handleClick = (text: string) => {
        let newSkip;
        switch (text) {
            case "Inicio":
                newSkip = 0;
                break;
            case "Anterior":
                newSkip = Math.max(0, skipPagination - (props.takePagination ?? 0));
                break;
            case "Siguiente":
                newSkip = skipPagination + (props.takePagination ?? 0);
                break;
            case "Último":
                newSkip = (props.totalPagesPagination ?? 1 - 1) * (props.takePagination ?? 0) - (props.takePagination ?? 0);
                break;
            default:
                break;
        }
        setSkipPagination(newSkip);
        if (props.onChangeSkip) props.onChangeSkip(newSkip);
    };
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: 'center'
        }}>
            <div style={{ display: 'flex' }}>
                {props.isLoading ? <Spinner size={SpinnerSize.small} /> : props?.cantidad}
                <Label style={{ padding: '0px 5px' }}> {' items de '} </Label>
                {props.isLoading ? <Spinner size={SpinnerSize.small} /> : props?.total}
            </div>
            <div style={{ display: "flex", alignItems: 'center', gap: '.3rem', /* width: 'auto'  */ }}>
                {props.isLoading ? <Spinner size={SpinnerSize.small} /> : (
                    <div key={"menu"}>
                        <Dropdown
                            styles={dropdownStyles}
                            selectedKey={MENU_ITEMS_PAGINACION.find(item => parseInt(item.key) === (props.takePagination ?? 0))?.key}
                            onChange={onCheckedValueChange}
                            options={MENU_ITEMS_PAGINACION.map(item => ({
                                text: `${item.text}`,
                                value: item.key,
                                key: item.key
                            }))}
                        />
                    </div>)}

                <div key={"descripcion"} style={{ display: 'flex' }}>
                    <Label >
                        {props.isLoading ? <Spinner typeof='small' /> : `Pág. ${props.actualPage} de ${props.totalPagesPagination}`}
                        {/* {props.isLoading ? <Spinner typeof='small' /> : `Página ${props.actualPage}  de`} */}
                    </Label>
                </div>
                <div key={"opciones"}>
                    <div style={{ display: 'flex' }}>

                        <IconButton
                            iconProps={{ iconName: 'Previous' }}
                            disabled={props.actualPage == 1 || props.actualPage == 0}
                            onClick={() => handleClick("Inicio")}
                            style={{
                                background: "#ffff",
                                border: "none",
                            }}
                        />

                        <IconButton
                            disabled={props.actualPage == 1 || props.actualPage == 0}
                            onClick={() => handleClick("Anterior")}
                            style={{
                                background: "#ffff",
                                border: "none",
                                fontSize: "12px"
                            }}
                        >
                            <FlechaMayor fill={`${props.actualPage === 1 || props.actualPage == 0 ? "#bdbdbd" : ""}`} />
                        </IconButton>

                        <IconButton
                            disabled={props.actualPage == props.totalPagesPagination}
                            onClick={() => handleClick("Siguiente")}
                            style={{
                                background: "#ffff",
                                border: "none",
                            }}
                        >
                            <FlechaMenor fill={`${props.actualPage === props.totalPagesPagination ? "#bdbdbd" : ""
                                }`} />
                        </IconButton>

                        <IconButton
                            iconProps={{ iconName: 'Next' }}
                            disabled={props.actualPage == props.totalPagesPagination}
                            onClick={() => handleClick("Último")}
                            style={{
                                background: "#ffff",
                                border: "none",
                            }}
                        />

                    </ div>
                </div>
            </div>
        </div>

    );


}